import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { ListItemText, ListItem, Typography, ListItemIcon, List, Button, Fab } from "@material-ui/core";
import Warning from "@material-ui/icons/Warning";
import Subject from "@material-ui/icons/Subject";
import Announcement from "@material-ui/icons/Announcement";
import Check from "@material-ui/icons/Check";
import { INotificationsStore } from "../Stores/NotificationsStore";
import { ISharedValuesStore } from "../Stores/SharedValuesStore";
import { SharedValues } from "../Tools/SharedValues";
import { Notification } from "./Notification";
import { STPopover } from "./styles";
import parse from "html-react-parser";
import DOMPurify from "dompurify";

interface IProps {
  isOpened: boolean;
  onClose: () => void;
  sharedValues?: ISharedValuesStore;
  notifications?: INotificationsStore;
  anchorEl: HTMLElement;
}

@inject("sharedValues", "notifications")
@observer
export default class NotificationsModal extends Component<IProps> {
  private notificationsCount: number = 0;

  markNotificationAsRead = (notification: Notification) => {
    this.props.notifications.markAsRead(notification.id);
  };

  handleNotificationReadClick = (event: any, notification: Notification) => {
    event.preventDefault();
    const { dataReadAndRedirectAttribute } = this.props.sharedValues;
    if (event.target.nodeName === "A" && event.target.attributes[dataReadAndRedirectAttribute]) {
      this.markNotificationAsRead(notification);
      const urlString = event.target.attributes[dataReadAndRedirectAttribute].value;
      if (window.location.host === new URL(urlString).host) {
        window.location.href = urlString;
      } else {
        window.open(urlString, "_blank");
      }
    }
  };

  handleAllNotificationsReadClick = (event: any) => {
    event.preventDefault();
    this.props.notifications.markAllAsRead();
    this.props.notifications.lastUnreadNotifications = [];
  };

  render() {
    const { notificationTypes, allowedHtmlTags } = this.props.sharedValues;
    let notifications = this.props.notifications.lastUnreadNotifications;
    const updatedNotificationsCount = notifications.length;
    if (this.notificationsCount < updatedNotificationsCount) {
      const audioEl = document.getElementsByClassName("audio-element")[0];
      if (audioEl) {
        const audioPromise = audioEl.play();
        audioPromise.catch((error: any) => {
          console.log(error);
        });
      }
    }
    this.notificationsCount = updatedNotificationsCount;
    return (
      <STPopover
        id="render-props-popover"
        open={this.props.isOpened}
        anchorEl={this.props.anchorEl}
        onClose={this.props.onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {this.notificationsCount > 0 && (
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" style={{ paddingLeft: "16px" }}>
              {SharedValues.getLocalizationValue("notifications")}
            </Typography>
            <Button
              style={{
                textTransform: "none",
                backgroundColor: "rgb(76, 175, 80)",
                color: "rgb(250, 250, 250)",
                margin: "8px",
                marginLeft: "16px",
              }}
              onClick={this.handleAllNotificationsReadClick}
            >
              {SharedValues.getLocalizationValue("clearAll")}
            </Button>
          </div>
        )}
        <List style={{ width: "100%", maxWidth: "500px" }}>
          {notifications.length > 0 ? (
            notifications.map((notification: Notification, index: number) => {
              return (
                <ListItem key={index} alignItems="flex-start">
                  <ListItemIcon style={{ marginRight: 0 }}>
                    {notification.type === notificationTypes.Warning ? (
                      <Warning />
                    ) : notification.type === notificationTypes.Announcement ? (
                      <Announcement />
                    ) : (
                      <Subject />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    style={{ marginTop: 6 }}
                    onClick={(event: any) => this.handleNotificationReadClick(event, notification)}
                  >
                    {parse(
                      DOMPurify.sanitize(notification.text, {
                        ALLOWED_TAGS: allowedHtmlTags,
                      })
                    )}
                    <div style={{ color: "#bdbdbd", fontSize: "14px" }}>
                      {new Date(notification.timeString).toLocaleString()}
                    </div>
                  </ListItemText>
                  <ListItemIcon style={{ marginTop: 0 }}>
                    <Fab
                      style={{
                        margin: 0,
                        marginLeft: 10,
                        transform: "scale(0.8)",
                        backgroundColor: "rgb(76, 175, 80)",
                        color: "rgb(250, 250, 250)",
                      }}
                      onClick={() => this.markNotificationAsRead(notification)}
                      size="small"
                    >
                      <Check />
                    </Fab>
                  </ListItemIcon>
                </ListItem>
              );
            })
          ) : (
            <Typography variant="body2" style={{ marginLeft: "10px", marginRight: "10px" }}>
              {SharedValues.getLocalizationValue("noNotifications")}
            </Typography>
          )}
        </List>
      </STPopover>
    );
  }
}
